
export default {
  name: 'ButtonDefault',

  components: {
  },

  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'large'
    },
    typeStyle: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    leftImg: {
      type: Object,
      default: null
    },
    leftSvg: {
      type: String,
      default: null
    },
    rightImg: {
      type: Object,
      default: null
    },
    rightSvg: {
      type: String,
      default: null
    },
    typeButton: {
      type: String,
      default: 'submit'
    }
  },

  emits: ['custom-click'],

  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {
  },

  methods: {
    customClick() {
      if (!this.disabled) this.$emit('custom-click');
    }
  }
};
